import ArticleShell from "@/components/site/ArticleShell";

const BodyEs = () => (
  <div className="article-body">
    <p>Marta había terminado su tratamiento hacía siete años. Sin recaídas, vida normal, alta médica. Pero el día que fue a pedir una hipoteca, el banco le pidió un seguro de vida. Y el seguro le pidió declarar todos sus antecedentes médicos. Cuando puso "cáncer de mama, 2018", la respuesta llegó en 48 horas: prima 4 veces más cara, o directamente rechazada.</p>

    <p>Esto, hasta hace muy poco, era legal en España. Hoy ya no lo es.</p>

    <p>Si has tenido cáncer y han pasado <strong>5 años desde el final de tu tratamiento sin recaídas</strong>, la ley te protege. No tienes obligación de declararlo. Las aseguradoras no pueden penalizarte ni rechazarte por ello.</p>

    <p>Se llama <strong>derecho al olvido oncológico</strong> y en este artículo te explico qué es, qué cubre, qué no, y cómo ejercerlo.</p>

    <h2>Qué es el derecho al olvido oncológico</h2>

    <p>Es un derecho legal que protege a las personas supervivientes de cáncer frente a la discriminación al contratar seguros de vida, hipotecas, préstamos personales o productos financieros similares.</p>

    <p>En términos prácticos:</p>

    <ul>
      <li>Han pasado <strong>5 años desde el final de tu tratamiento activo sin recaídas</strong>.</li>
      <li>Desde ese momento <strong>no estás obligada a declarar tu historial oncológico</strong> en ningún cuestionario de salud para contratar estos productos.</li>
      <li>La entidad <strong>no puede negarte el contrato</strong>, ni aplicarte primas más altas, ni excluir coberturas por ese motivo.</li>
      <li>Si lo hace, está cometiendo una <strong>infracción legal</strong>.</li>
    </ul>

    <h2>De dónde viene esta ley</h2>

    <p>Hasta hace poco, en España, una persona que había tenido cáncer hace 15 años seguía teniendo que declararlo toda su vida. Eso significaba en la práctica:</p>

    <ul>
      <li>Hipotecas más caras o denegadas.</li>
      <li>Imposibilidad de contratar seguros de vida razonables.</li>
      <li>Dificultad para acceder a préstamos personales y a determinadas actividades laborales.</li>
      <li>Una <strong>"penalización vitalicia"</strong> por algo que ya estaba superado.</li>
    </ul>

    <p>El movimiento europeo empezó en <strong>Francia (2016)</strong>, que aprobó un derecho al olvido oncológico inicialmente a 10 años, luego reducido a 5. Le siguieron Bélgica, Países Bajos, Luxemburgo y Portugal.</p>

    <p>En <strong>España, en junio de 2023</strong>, el Real Decreto-ley 5/2023 introdujo el derecho al olvido oncológico modificando la Ley de Contrato de Seguro y la Ley General para la Defensa de los Consumidores y Usuarios. Una conquista colectiva impulsada por asociaciones de pacientes, oncológas y juristas.</p>

    <blockquote>El cáncer ya no es para toda la vida en términos administrativos. Y eso es justicia, no favor.</blockquote>

    <h2>Qué cubre exactamente</h2>

    <p>El derecho al olvido oncológico se aplica a:</p>

    <ol>
      <li><strong>Contratos de seguro</strong>: vida, salud, accidentes, decesos. No puedes ser obligada a declarar tu historial oncológico una vez pasados los 5 años.</li>
      <li><strong>Productos financieros vinculados a un seguro</strong>: hipotecas, préstamos personales, créditos al consumo cuando exigen un seguro de vida asociado.</li>
      <li><strong>Cualquier formulario o cuestionario de salud</strong> emitido por estas entidades.</li>
    </ol>

    <p>Si la entidad pregunta, puedes <strong>responder honestamente que no tienes nada que declarar</strong>. Y si descubren después tu historial, no pueden anular el contrato ni aplicarte penalizaciones retroactivas por no haberlo declarado: la ley te ampara.</p>

    <h2>Qué NO cubre</h2>

    <p>Hay tres matices importantes:</p>

    <ul>
      <li><strong>Si han pasado menos de 5 años</strong> desde el final del tratamiento, todavía estás obligada a declararlo. Algunos países europeos ya están reduciendo el plazo a 10 años para cánceres pediátricos o ciertos perfiles. España todavía no.</li>
      <li><strong>Si tu cáncer está activo o estás en tratamiento</strong>, tampoco aplica.</li>
      <li>El derecho <strong>no obliga a las aseguradoras a ofrecerte productos</strong>: solo les prohíbe penalizarte por el cáncer pasado. Pueden seguir aplicando otros criterios (edad, otras enfermedades activas, etc.).</li>
    </ul>

    <h2>Cómo ejercerlo en la práctica</h2>

    <h3>1. Cuenta los 5 años desde el final del tratamiento, no desde el diagnóstico</h3>
    <p>"Final del tratamiento activo" significa: última quimio, última radio, última cirugía oncológica, último tratamiento hormonal con finalidad curativa. La hormonoterapia adyuvante prolongada (5-10 años) sigue siendo motivo de debate; consulta con tu oncóloga para saber qué fecha aplicar.</p>

    <h3>2. Cuando te pasen un cuestionario de salud para seguro o hipoteca</h3>
    <p>Lee bien las preguntas. Si han pasado los 5 años:</p>
    <ul>
      <li>Responde <strong>"No"</strong> a "¿Ha tenido cáncer?" sin culpa. La ley te ampara.</li>
      <li>Si te lo preguntan oralmente, lo mismo.</li>
      <li>Si la entidad te lo pone difícil, recuérdales el <strong>Real Decreto-ley 5/2023</strong> y la modificación de la Ley 50/1980 de Contrato de Seguro.</li>
    </ul>

    <h3>3. Si te rechazan o te aplican una sobreprima</h3>
    <ul>
      <li>Pide la <strong>negativa por escrito</strong>, explicando el motivo.</li>
      <li>Reclama ante el <strong>Servicio de Atención al Cliente</strong> de la entidad.</li>
      <li>Si no responden, escala a la <strong>Dirección General de Seguros y Fondos de Pensiones (DGSFP)</strong>.</li>
      <li>Y para apoyo, contacta con la <strong>AECC (Asociación Española Contra el Cáncer)</strong>, que está acompañando muchos casos de aplicación de esta ley.</li>
    </ul>

    <h2>Por qué te lo cuento desde el Método TAO</h2>

    <p>Porque acompañar a personas con cáncer no es solo trabajar respiración, regulación del sistema nervioso o autocompasión. Es también ayudarte a habitar tu vida después con dignidad. Y la vida después incluye <strong>la hipoteca, el seguro, el futuro financiero, el derecho a que el cáncer no sea una marca vitalicia</strong>.</p>

    <p>Mucha gente todavía no sabe que esta ley existe. Si conoces a alguien que pueda necesitarla, comparte este artículo.</p>

    <blockquote>El cáncer cambia muchas cosas. Pero no debería cambiar tu acceso a una vida administrativa normal cinco años después de haber salido de él.</blockquote>

    <h2>Recursos útiles</h2>

    <ul>
      <li><strong>AECC</strong> (Asociación Española Contra el Cáncer): información jurídica gratuita para supervivientes.</li>
      <li><strong>Federación Española de Cáncer de Mama (FECMA)</strong>.</li>
      <li><strong>GEPAC</strong> (Grupo Español de Pacientes con Cáncer).</li>
      <li>Para Cataluña: <strong>FECEC</strong> (Federació Catalana d'Entitats Contra el Càncer).</li>
    </ul>

    <h2>Si necesitas hablar con alguien</h2>

    <p>En el Método TAO acompañamos también el "después". Esa parte del proceso que parece que ya está resuelta pero a veces es la más compleja: volver a habitar la vida, el cuerpo, el futuro.</p>

    <p>Te invito a una <strong>llamada gratuita de 15 minutos</strong>. Sin compromiso.</p>
  </div>
);

const BodyCa = () => (
  <div className="article-body">
    <p>La Marta havia acabat el tractament feia set anys. Sense recaigudes, vida normal, alta mèdica. Però el dia que va anar a demanar una hipoteca, el banc li va demanar una assegurança de vida. I l'assegurança li va demanar declarar tots els antecedents mèdics. Quan va posar "càncer de mama, 2018", la resposta va arribar en 48 hores: prima 4 vegades més cara, o directament rebutjada.</p>

    <p>Això, fins fa molt poc, era legal a Espanya. Avui ja no ho és.</p>

    <p>Si has tingut càncer i han passat <strong>5 anys des del final del teu tractament sense recaigudes</strong>, la llei et protegeix. No tens obligació de declarar-ho. Les asseguradores no et poden penalitzar ni rebutjar per aquest motiu.</p>

    <p>Es diu <strong>dret a l'oblit oncològic</strong> i en aquest article t'explico què és, què cobreix, què no, i com exercir-lo.</p>

    <h2>Què és el dret a l'oblit oncològic</h2>

    <p>És un dret legal que protegeix les persones supervivents de càncer davant la discriminació en contractar assegurances de vida, hipoteques, préstecs personals o productes financers similars.</p>

    <p>En termes pràctics:</p>

    <ul>
      <li>Han passat <strong>5 anys des del final del teu tractament actiu sense recaigudes</strong>.</li>
      <li>Des d'aquell moment <strong>no estàs obligada a declarar el teu historial oncològic</strong> en cap qüestionari de salut per contractar aquests productes.</li>
      <li>L'entitat <strong>no et pot negar el contracte</strong>, ni aplicar-te primes més altes, ni excloure cobertures per aquest motiu.</li>
      <li>Si ho fa, està cometent una <strong>infracció legal</strong>.</li>
    </ul>

    <h2>D'on ve aquesta llei</h2>

    <p>Fins fa poc, a Espanya, una persona que havia tingut càncer feia 15 anys havia de continuar declarant-ho tota la vida. Això significava, a la pràctica:</p>

    <ul>
      <li>Hipoteques més cares o denegades.</li>
      <li>Impossibilitat de contractar assegurances de vida raonables.</li>
      <li>Dificultat per accedir a préstecs personals i a determinades activitats laborals.</li>
      <li>Una <strong>"penalització vitalícia"</strong> per alguna cosa que ja estava superada.</li>
    </ul>

    <p>El moviment europeu va començar a <strong>França (2016)</strong>, que va aprovar un dret a l'oblit oncològic inicialment a 10 anys, després reduït a 5. El van seguir Bèlgica, Països Baixos, Luxemburg i Portugal.</p>

    <p>A <strong>Espanya, el juny de 2023</strong>, el Reial Decret-llei 5/2023 va introduir el dret a l'oblit oncològic modificant la Llei de Contracte d'Assegurança i la Llei General per a la Defensa dels Consumidors i Usuaris. Una conquesta col·lectiva impulsada per associacions de pacients, oncòlogues i juristes.</p>

    <blockquote>El càncer ja no és per a tota la vida en termes administratius. I això és justícia, no pas favor.</blockquote>

    <h2>Què cobreix exactament</h2>

    <p>El dret a l'oblit oncològic s'aplica a:</p>

    <ol>
      <li><strong>Contractes d'assegurança</strong>: vida, salut, accidents, decessos. No pots ser obligada a declarar el teu historial oncològic un cop han passat els 5 anys.</li>
      <li><strong>Productes financers vinculats a una assegurança</strong>: hipoteques, préstecs personals, crèdits al consum quan exigeixen una assegurança de vida associada.</li>
      <li><strong>Qualsevol formulari o qüestionari de salut</strong> emès per aquestes entitats.</li>
    </ol>

    <p>Si l'entitat pregunta, pots <strong>respondre honestament que no tens res a declarar</strong>. I si descobreixen després el teu historial, no poden anul·lar el contracte ni aplicar-te penalitzacions retroactives per no haver-ho declarat: la llei t'empara.</p>

    <h2>Què NO cobreix</h2>

    <p>Hi ha tres matisos importants:</p>

    <ul>
      <li><strong>Si han passat menys de 5 anys</strong> des del final del tractament, encara estàs obligada a declarar-ho. Alguns països europeus ja estan reduint el termini a 10 anys per a càncers pediàtrics o certs perfils. Espanya encara no.</li>
      <li><strong>Si el teu càncer està actiu o estàs en tractament</strong>, tampoc no s'aplica.</li>
      <li>El dret <strong>no obliga les asseguradores a oferir-te productes</strong>: només els prohibeix penalitzar-te pel càncer passat. Poden continuar aplicant altres criteris (edat, altres malalties actives, etc.).</li>
    </ul>

    <h2>Com exercir-lo a la pràctica</h2>

    <h3>1. Compta els 5 anys des del final del tractament, no des del diagnòstic</h3>
    <p>"Final del tractament actiu" vol dir: última quimio, última ràdio, última cirurgia oncològica, últim tractament hormonal amb finalitat curativa. L'hormonoteràpia adjuvant prolongada (5-10 anys) continua sent motiu de debat; consulta amb la teva oncòloga per saber quina data aplicar.</p>

    <h3>2. Quan et passin un qüestionari de salut per a assegurança o hipoteca</h3>
    <p>Llegeix bé les preguntes. Si han passat els 5 anys:</p>
    <ul>
      <li>Respon <strong>"No"</strong> a "Ha tingut càncer?" sense culpa. La llei t'empara.</li>
      <li>Si t'ho pregunten oralment, el mateix.</li>
      <li>Si l'entitat t'ho posa difícil, recorda'ls el <strong>Reial Decret-llei 5/2023</strong> i la modificació de la Llei 50/1980 de Contracte d'Assegurança.</li>
    </ul>

    <h3>3. Si et rebutgen o t'apliquen una sobreprima</h3>
    <ul>
      <li>Demana la <strong>negativa per escrit</strong>, explicant el motiu.</li>
      <li>Reclama davant el <strong>Servei d'Atenció al Client</strong> de l'entitat.</li>
      <li>Si no responen, escala a la <strong>Direcció General d'Assegurances i Fons de Pensions (DGSFP)</strong>.</li>
      <li>I per a suport, contacta amb l'<strong>AECC (Asociación Española Contra el Cáncer)</strong> o, a Catalunya, amb la <strong>FECEC (Federació Catalana d'Entitats Contra el Càncer)</strong>, que estan acompanyant molts casos d'aplicació d'aquesta llei.</li>
    </ul>

    <h2>Per què t'ho explico des del Mètode TAO</h2>

    <p>Perquè acompanyar persones amb càncer no és només treballar respiració, regulació del sistema nerviós o autocompassió. És també ajudar-te a habitar la vida després amb dignitat. I la vida després inclou <strong>la hipoteca, l'assegurança, el futur financer, el dret que el càncer no sigui una marca vitalícia</strong>.</p>

    <p>Molta gent encara no sap que aquesta llei existeix. Si coneixes algú que la pugui necessitar, comparteix aquest article.</p>

    <blockquote>El càncer canvia moltes coses. Però no hauria de canviar el teu accés a una vida administrativa normal cinc anys després d'haver-ne sortit.</blockquote>

    <h2>Recursos útils</h2>

    <ul>
      <li><strong>AECC</strong> (Asociación Española Contra el Cáncer): informació jurídica gratuïta per a supervivents.</li>
      <li><strong>FECMA</strong> (Federació Espanyola de Càncer de Mama).</li>
      <li><strong>GEPAC</strong> (Grup Espanyol de Pacients amb Càncer).</li>
      <li>A Catalunya: <strong>FECEC</strong> (Federació Catalana d'Entitats Contra el Càncer).</li>
    </ul>

    <h2>Si necessites parlar amb algú</h2>

    <p>Al Mètode TAO acompanyem també el "després". Aquella part del procés que sembla que ja està resolta però que de vegades és la més complexa: tornar a habitar la vida, el cos, el futur.</p>

    <p>Et convido a una <strong>trucada gratuïta de 15 minuts</strong>. Sense compromís.</p>
  </div>
);

const ArticleDerechoOlvidoOncologico = () => (
  <ArticleShell
    bodyEs={<BodyEs />}
    bodyCa={<BodyCa />}
    leadMagnet={{
      guide: "post-cancer",
      source: "blog/derecho-olvido-oncologico",
      title: {
        es: "Volver a habitar la vida después del cáncer",
        ca: "Tornar a habitar la vida després del càncer",
      },
      subtitle: {
        es: "Si te ha resonado este artículo, te dejo una mini-guía con 5 prácticas cuerpo-mente para reconstruir la vida después del cáncer. Sin culpa, sin exigencia.",
        ca: "Si t'ha ressonat aquest article, et deixo una mini-guia amb 5 pràctiques cos-ment per reconstruir la vida després del càncer. Sense culpa, sense exigència.",
      },
      bullets: {
        es: [
          "5 prácticas cuerpo-mente para el post-cáncer",
          "Para los duelos invisibles del 'después'",
          "Sin esfuerzo físico — todo desde la escucha",
          "La recibes en tu email en menos de 5 minutos",
        ],
        ca: [
          "5 pràctiques cos-ment per al post-càncer",
          "Per als dols invisibles del 'després'",
          "Sense esforç físic — tot des de l'escolta",
          "La reps al teu email en menys de 5 minuts",
        ],
      },
    }}
  />
);

export default ArticleDerechoOlvidoOncologico;
